export default "/_next/static/images/ceo-signature-e6edd84ffcca602389fddfc1d72db8b3.jpg";